import moment from 'moment';

export const format2Digit = Intl.NumberFormat('en-US', {
	minimumIntegerDigits: 2,
});

export const getFirstWkMonth = (month, year) => {
	return moment()
		.clone()
		.set('month', month)
		.set('year', year)
		.startOf('month');
};

export const getLastWkMonth = (month, year) => {
	return moment().clone().set('month', month).set('year', year).endOf('month');
};

export const getFirstWeekNumberYearBased = (year, month) => {
	return moment()
		.clone()
		.set('year', year)
		.set('month', month)
		.startOf('month');
};
